<template>
  <UApp>
    <SessionToken>
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>
    </SessionToken>
  </UApp>
</template>
